'use client'

import s from './ContactUs.module.scss';
import {Form} from "@/app/[locale]/common/components/Form/Form";
import {ContactInfo} from "@/app/[locale]/common/components/ContactInfo/ContactInfo";
import {PhoneContactIcon} from "@/app/[locale]/common/assets/PhoneContactIcon/PhoneContactIcon";
import {EmailContactIcon} from "@/app/[locale]/common/assets/EmailContactIcon/EmailContactIcon";
import {useResponsive} from "@/app/[locale]/common/utils/hooks/useResponsive/useResponsive";
import {useEffect, useState} from "react";
import {CONTACT_INFO} from "../../constants/main";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {TContactUsProps} from "@/app/[locale]/common/components/ContactUs/types";
import {useTranslations} from "next-intl";
import {Preloader} from "@/app/[locale]/common/components/Preloader/Preloader";

export const ContactUs = ({ title = true }: TContactUsProps) => {
    const [ map, setMap ] = useState<string | null>(null);
    const t = useTranslations('MainPage.ContactUs');

    useEffect(() => {
        setMap(CONTACT_INFO.GOOGLE_MAP_LINK);
    }, []);

    const version = useResponsive('desktop', 'mobile', 600) as 'desktop' | 'mobile';
    const formButtonSize = version === 'desktop' ? 'large' : 'mobile';

    return (
        <section className={s.contact}>
            { title && <Title title={t('title')} /> }
            <div className={s.contact_content}>
                <div className={s.contact_form}>
                    <div className={s.contact_form_info}>
                        <ContactInfo
                            title={CONTACT_INFO.PHONE}
                            version={'phone'}
                            Icon={PhoneContactIcon}
                        />
                        <ContactInfo
                            title={CONTACT_INFO.EMAIL}
                            version={'email'}
                            Icon={EmailContactIcon}
                        />
                    </div>
                    <Form
                        version={version}
                        buttonSize={formButtonSize}
                        buttonPosition={'start'}
                        className={s.contact_form_body}
                    />
                </div>
                <div className={s.contact_map}>
                    {
                        map ?
                            <iframe
                                src={map}
                                width="100%" height="100%" loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"></iframe> :
                            <Preloader/>
                    }
                </div>
            </div>
        </section>
    );
};
